import {
  TransactionStatus,
  TransactionStatusLabel,
  VatType,
  VatTypeLabel,
} from '../../../../../_interfaces/transactions.interface';
import { FilterGroupType } from '../../../../../shared/components/filter-button/filter-button.component';
import { SelectOption } from '../../../../../_interfaces/select-field.interface';

// VAT options for ng-select
export const vatOptions: SelectOption[] = [
  { option: VatTypeLabel.STANDARD, value: VatType.STANDARD.toString() },
  { option: VatTypeLabel.CAPITALGOODS, value: VatType.CAPITALGOODS.toString() },
  { option: VatTypeLabel.ZERO_RATE, value: VatType.ZERO_RATE.toString() },
  { option: VatTypeLabel.EXEMPT, value: VatType.EXEMPT.toString() },
  { option: VatTypeLabel.NOVAT, value: VatType.NOVAT.toString() },
];

export const defaultVatType = VatType.STANDARD;

export const categoryTransactionsTableColumn = { prop: 'category', name: 'Category', flexGrow: 1, minWidth: 150 };

export const baseStartTransactionTableColumns = [
  { prop: 'timestamp', name: 'Date', orderingParam: 'date', flexGrow: 1, minWidth: 100 },
  { prop: 'first_name', name: 'First name', flexGrow: 1, minWidth: 100 },
  { prop: 'last_name', name: 'Last name', flexGrow: 1, minWidth: 100 },
];

export const baseEndTransactionTableColumns = [
  {
    prop: 'amount',
    name: 'Amount',
    flexGrow: 1,
    cellClass: 'text-end',
    headerClass: 'text-end',
    minWidth: 100,
  },
  {
    prop: 'receipt_status',
    name: 'Receipt',
    flexGrow: 1,
    sortable: false,
    canAutoResize: false,
    width: 80,
    resizeable: false,
  },
  {
    prop: 'actions',
    name: '',
    sortable: false,
    width: 60,
    resizeable: false,
    canAutoResize: false,
  },
];

export const hasAccountingTransactionTableColumns = [
  ...baseStartTransactionTableColumns,
  { prop: 'contact', orderingParam: 'contact', name: 'Contact', flexGrow: 1, minWidth: 100 },
  categoryTransactionsTableColumn,
  {
    prop: 'status',
    name: 'Status',
    flexGrow: 1,
    minWidth: 150,
    cellClass: 'text-center',
    headerClass: 'text-center',
  },
  ...baseEndTransactionTableColumns,
];

export const noAccountingTransactionTableColumns = [
  ...baseStartTransactionTableColumns,
  { prop: 'merchant', name: 'Merchant', flexGrow: 1, minWidth: 100 },
  categoryTransactionsTableColumn,
  ...baseEndTransactionTableColumns,
];

export const depositTableColumns = [
  { prop: 'timestamp', name: 'Date', orderingParam: 'date', flexGrow: 1, minWidth: 100 },
  { prop: 'description', name: 'Description', sortable: false, flexGrow: 2, minWidth: 100 },

  {
    prop: 'amount',
    name: 'Amount',
    flexGrow: 1,
    cellClass: 'text-end',
    headerClass: 'text-end',
    minWidth: 100,
  },
  {
    prop: 'status',
    name: 'Status',
    flexGrow: 1,
    minWidth: 120,
    cellClass: 'text-center',
    headerClass: 'text-center',
  },
];

export const categoryTableColumns = [
  {
    prop: 'actions',
    name: '',
    sortable: false,
    width: 100,
    resizeable: false,
    canAutoResize: false,
    cellClass: 'text-end',
  },
];

export const hasAccountingCategoryColumns = [
  {
    prop: 'account',
    orderingParam: 'account_name',
    name: 'Account',
    flexGrow: 1,
    minWidth: 150,
  },
  {
    prop: 'name',
    orderingParam: 'category_name',
    name: 'Display name',
    flexGrow: 1,
    minWidth: 150,
  },
  ...categoryTableColumns,
];

export const noAccountingCategoryColumns = [
  {
    prop: 'name',
    name: 'Paystashio category',
    orderingParam: 'category_name',
    flexGrow: 1,
    minWidth: 150,
  },
  ...categoryTableColumns,
];

export function generateTransactionFilterGroups(receiptQuery: string, statusQuery: string[]) {
  return [
    {
      filterLabel: 'Receipts',
      param: 'receipt',
      type: FilterGroupType.radio,
      options: [
        {
          label: 'With receipts',
          value: true,
          type: FilterGroupType.radio,
          checked: receiptQuery === 'true',
        },
        {
          label: 'Without receipts',
          value: false,
          type: FilterGroupType.radio,
          checked: receiptQuery === 'false',
        },
      ],
    },
    {
      filterLabel: 'Status',
      param: 'status',
      options: [
        {
          label: TransactionStatusLabel.NEW,
          value: TransactionStatus.NEW,
          type: FilterGroupType.checkbox,
          checked: statusQuery.includes(TransactionStatus.NEW.toString()),
        },
        {
          label: TransactionStatusLabel.READY,
          value: TransactionStatus.READY,
          type: FilterGroupType.checkbox,
          checked: statusQuery.includes(TransactionStatus.READY.toString()),
        },
        {
          label: TransactionStatusLabel.SYNCHED,
          value: TransactionStatus.SYNCHED,
          type: FilterGroupType.checkbox,
          checked: statusQuery.includes(TransactionStatus.SYNCHED.toString()),
        },
        {
          label: 'Sync failed',
          value: TransactionStatus.ERROR,
          type: FilterGroupType.checkbox,
          checked: statusQuery.includes(TransactionStatus.ERROR.toString()),
        },
      ],
    },
  ];
}
